import { createFileRoute } from '@tanstack/react-router';

import { SchedulePage } from '@/features/parent/SchedulePage';

export const Route = createFileRoute('/_authed/parent/schedule')({
  component: SchedulePage,
});
